// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select_input {
    display: inline-block;
    position: relative;
    color: var(--color-text);
    cursor: pointer;
    user-select: none;
    flex: 1;
    min-width: 0;
}

.select_input .context_menu {
    position: absolute;
    top: 29px;
    left: 0;
    width: 100%;
}

.select_input .context_menu__popup {
    width: 100%;
}

.select_input_wrapper {
    width: 100%;
    padding-right: 22px;
    height: 29px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    border: 1px solid var(--color-border);
}

.select_input__value {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;
    font-weight: 500;
    color: var(--color-text);
    flex: 1;
    min-width: 0;
}

.select_input__value--placeholder {
    color: var(--color-text-muted);
    font-style: italic;
}

.select_input__arrow {
    position: absolute;
    right: 7px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 6px solid var(--color-text-muted);
    flex-shrink: 0;
}

.select_input.expanded .select_input__arrow {
    border-top: none;
    border-bottom: 6px solid var(--color-text-muted);
}

/* ── searchable mode ─────────────────────────────────────────────────────── */

.select_input__backdrop {
    position: fixed;
    inset: 0;
    z-index: 2999;
}

.select_input__popup {
    position: absolute;
    top: 29px;
    left: 0;
    right: 0;
    z-index: 3000;
    display: flex;
    flex-direction: column;
    border: 1px solid var(--color-border);
    background-color: var(--color-bg-2);
    border-radius: 3px;
    box-shadow: 0 4px 13px rgba(0, 0, 0, 0.3);
    cursor: default;
}

.select_input__search {
    margin: 4px;
    width: calc(100% - 8px);
    box-sizing: border-box;
}

.select_input__list {
    list-style: none;
    margin: 0;
    padding: 2px 0;
    max-height: 320px;
    overflow-y: auto;
}

.select_input__group {
    padding: 6px 11px 2px;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--color-text-muted);
}

.select_input__option {
    display: flex;
    align-items: baseline;
    gap: 8px;
    padding: 4px 11px;
    font-size: 14px;
    cursor: pointer;
    white-space: nowrap;
    color: var(--color-text);
}

.select_input__option.selected .select_input__option_title {
    color: var(--color-accent);
}

.select_input__option.disabled {
    cursor: default;
    color: var(--color-text-muted);
}

/* The name wins the space; the raw-id hint shrinks first. */
.select_input__option_title {
    flex: 0 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
}

.select_input__option_title:not(:last-child) {
    max-width: 75%;
}

.select_input__option_hint {
    flex: 1 1 0;
    min-width: 0;
    text-align: right;
    font-size: 12px;
    color: var(--color-text-muted);
    overflow: hidden;
    text-overflow: ellipsis;
}

.select_input__option.focused:not(.disabled) {
    background-color: var(--color-bg-3);
}

.select_input__empty {
    padding: 6px 11px;
    font-size: 13px;
    font-style: italic;
    color: var(--color-text-muted);
}
`, "",{"version":3,"sources":["webpack://./components/toolkit/SelectInput/s.select_input.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,iBAAiB;IACjB,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,6CAA6C;IAC7C,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gDAAgD;AACpD;;AAEA,+EAA+E;;AAE/E;IACI,eAAe;IACf,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,qCAAqC;IACrC,mCAAmC;IACnC,kBAAkB;IAClB,yCAAyC;IACzC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA,4DAA4D;AAC5D;IACI,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,8BAA8B;IAC9B,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,8BAA8B;AAClC","sourcesContent":[".select_input {\n    display: inline-block;\n    position: relative;\n    color: var(--color-text);\n    cursor: pointer;\n    user-select: none;\n    flex: 1;\n    min-width: 0;\n}\n\n.select_input .context_menu {\n    position: absolute;\n    top: 29px;\n    left: 0;\n    width: 100%;\n}\n\n.select_input .context_menu__popup {\n    width: 100%;\n}\n\n.select_input_wrapper {\n    width: 100%;\n    padding-right: 22px;\n    height: 29px;\n    display: flex;\n    align-items: center;\n    box-sizing: border-box;\n    border: 1px solid var(--color-border);\n}\n\n.select_input__value {\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--color-text);\n    flex: 1;\n    min-width: 0;\n}\n\n.select_input__value--placeholder {\n    color: var(--color-text-muted);\n    font-style: italic;\n}\n\n.select_input__arrow {\n    position: absolute;\n    right: 7px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 0;\n    height: 0;\n    border-left: 4px solid transparent;\n    border-right: 4px solid transparent;\n    border-top: 6px solid var(--color-text-muted);\n    flex-shrink: 0;\n}\n\n.select_input.expanded .select_input__arrow {\n    border-top: none;\n    border-bottom: 6px solid var(--color-text-muted);\n}\n\n/* ── searchable mode ─────────────────────────────────────────────────────── */\n\n.select_input__backdrop {\n    position: fixed;\n    inset: 0;\n    z-index: 2999;\n}\n\n.select_input__popup {\n    position: absolute;\n    top: 29px;\n    left: 0;\n    right: 0;\n    z-index: 3000;\n    display: flex;\n    flex-direction: column;\n    border: 1px solid var(--color-border);\n    background-color: var(--color-bg-2);\n    border-radius: 3px;\n    box-shadow: 0 4px 13px rgba(0, 0, 0, 0.3);\n    cursor: default;\n}\n\n.select_input__search {\n    margin: 4px;\n    width: calc(100% - 8px);\n    box-sizing: border-box;\n}\n\n.select_input__list {\n    list-style: none;\n    margin: 0;\n    padding: 2px 0;\n    max-height: 320px;\n    overflow-y: auto;\n}\n\n.select_input__group {\n    padding: 6px 11px 2px;\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: var(--color-text-muted);\n}\n\n.select_input__option {\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n    padding: 4px 11px;\n    font-size: 14px;\n    cursor: pointer;\n    white-space: nowrap;\n    color: var(--color-text);\n}\n\n.select_input__option.selected .select_input__option_title {\n    color: var(--color-accent);\n}\n\n.select_input__option.disabled {\n    cursor: default;\n    color: var(--color-text-muted);\n}\n\n/* The name wins the space; the raw-id hint shrinks first. */\n.select_input__option_title {\n    flex: 0 1 auto;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.select_input__option_title:not(:last-child) {\n    max-width: 75%;\n}\n\n.select_input__option_hint {\n    flex: 1 1 0;\n    min-width: 0;\n    text-align: right;\n    font-size: 12px;\n    color: var(--color-text-muted);\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.select_input__option.focused:not(.disabled) {\n    background-color: var(--color-bg-3);\n}\n\n.select_input__empty {\n    padding: 6px 11px;\n    font-size: 13px;\n    font-style: italic;\n    color: var(--color-text-muted);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
